import React from "react";

import borrowedClass from "../SideBar/Sidebar.module.css";
import classes from "./MiniSideBar.module.css";

export default function MiniSideBar(props) {
  let class_name = classes.MiniSideBar;
  if (props.extraClass) class_name += " " + classes.Second;
  return (
    <aside className={class_name}>
      <nav>
        <ul className={classes.NavItems}>
          <li className={classes.ActiveItem}>
            <i className="fas fa-home" />
            <span>Home</span>
          </li>
          <li>
            <i className="fas fa-fire" />
            <span>Trending</span>
          </li>
          <li>
            <div className={borrowedClass.Youtube_Subscriptions}>
              <span />
              <span />
              <i className="fab fa-youtube" />
            </div>
            <span>Subscriptions</span>
          </li>
          <li>
            <i className="fas fa-folder" />
            <span>Library</span>
          </li>
          <li>
            <i className="fas fa-history" />
            <span>History</span>
          </li>
        </ul>
      </nav>
    </aside>
  );
}
